import {ICollapsibleProps} from "./ICollapsibleProps";
import React from "react";
import {ICollapsibleState} from "./ICollapsibleState";
import './Collapsible.css';
import PlusIcon from "../../resources/wrappers/PlusIcon";
import MinusIcon from "../../resources/wrappers/MinusIcon";

export default class Collapsible extends React.Component<ICollapsibleProps, ICollapsibleState>{
    constructor(props: ICollapsibleProps) {
        super(props);
        this.state = {
            open: false
        }

        this.togglePanel = this.togglePanel.bind(this);
    }

    togglePanel(event: any){
        this.setState({open: !this.state.open})
    }

    render() {
        return (
            <div>
                <div onClick={this.props.elements !== undefined && this.props.elements.length > 0 ? (event) => this.togglePanel(event) : () => {}}
                     className={"collapsible-header-container"} style={(this.props.elements === undefined || this.props.elements.length === 0) ? {cursor: "default"} : {cursor: "pointer"}}>
                    <p className={"collapsible-header-element"}>{this.props.header}</p>
                    {this.props.elements !== undefined && this.props.elements.length > 0 ? <div className={"collapsible-header-icon"}>
                        {!this.state.open ? <PlusIcon width={'15px'} height={'15px'}/> : <MinusIcon width={'15px'} height={'15px'} />}
                    </div> : <div className={"collapsible-header-icon"}/>}
                </div>
                {this.state.open ? (
                    <div className={"collapsible-content"}>
                        {this.props.elements?.map((elem) => {
                            return (<p className={"collapsible-content-element"}>{elem}</p>)
                        })}
                    </div>
                ) : null}
            </div>
        );
    }
}